import { Fieldset, TextInput } from '@audio-network/componentlibrary'
import React, { FormEvent, useEffect, useRef } from 'react'
import { useInstantSearch, useRefinementList } from 'react-instantsearch'

import { Button } from '@audio-network/componentlibrary'
import ExplicitFilter from '../ExplicitFilter/ExplicitFilter'
import VocalFilter from '../VocalFilter/VocalFilter'
import styles from './LyricsFilter.module.css'
import { useTranslation } from 'next-i18next'

const LyricsFilter = (
	props: JSX.IntrinsicAttributes &
		React.ClassAttributes<HTMLDivElement> &
		React.HTMLAttributes<HTMLDivElement>
): JSX.Element => {
	const { t } = useTranslation(['search'])
	const { setIndexUiState, indexUiState } = useInstantSearch()
	const inputRef = useRef(null)
	//Need to mount the widget for this to work:
	//https://www.algolia.com/doc/api-reference/widgets/use-instantsearch/react/#widget-param-setindexuistate
	useRefinementList({
		attribute: 'LyricsList',
		operator: 'and',
		sortBy: ['name'],
		limit: 1, //Dont show these anywhere yet
	})

	const buildLyricsList = (): string[] => {
		const lyricsArray = inputRef?.current?.value
			.toLowerCase()
			.replace(/\s\s+/g, ' ') //Remove multiple spaces, tabs, new lines etc with a single space
			.replace(/[^a-z0-9 ]/g, '')
			.trim()
			.split(' ')
			.filter((item) => item !== '') //Remove empty lyric search terms

		inputRef.current.value = lyricsArray.join(' ')
		//If no valid filter exists the pass an empty array
		if (lyricsArray[0] === '') {
			return []
		} else {
			return lyricsArray
		}
	}

	useEffect(() => {
		const lyricsRefinementList =
			indexUiState?.refinementList === undefined
				? null
				: indexUiState?.refinementList['LyricsList']

		if (lyricsRefinementList) {
			inputRef.current.value = lyricsRefinementList.join(' ')
		} else {
			inputRef.current.value = ''
		}
	}, [indexUiState?.refinementList])

	const filterByLyrics = (event: FormEvent): void => {
		event.preventDefault()
		event.stopPropagation()
		const lyricsList = buildLyricsList()
		setIndexUiState((prevUIState) => ({
			...prevUIState,
			refinementList: {
				...prevUIState.refinementList,
				LyricsList: lyricsList,
			},
		}))
	}

	return (
		<div className={styles.vocalsAndLyrics} {...props}>
			<Fieldset legend={t('vocals')} className={styles.label}>
				<VocalFilter />
				<ExplicitFilter />
			</Fieldset>
			<form className={styles.lyrics}>
				<TextInput
					autoComplete="off"
					className={styles.input}
					name="lyrics-search"
					label={t('lyrics-search')}
					ref={inputRef}
					role="searchbox"
					type="text"
				/>
				<div className={styles.buttonContainer}>
					<Button
						onClick={filterByLyrics}
						size="S"
						variant="secondary"
						data-testid="lyrics-button"
						type="submit"
					>
						{t('lyrics-search-button')}
					</Button>
				</div>
			</form>
		</div>
	)
}

export default LyricsFilter
